/* Hero hotspots: one open at a time, hover on desktop, click/keyboard everywhere, ESC/outside closes. */
(() => {
  'use strict';
  if (customElements.get('purr-hotspots')) return;
  class PurrHotspots extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.spots = Array.from(this.querySelectorAll('.purr-hotspot'));
      if (!this.spots.length) return;
      const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.spots.forEach((spot) => {
        const btn = spot.querySelector('.purr-hotspot__btn');
        const card = spot.querySelector('.purr-hotspot__card');
        if (!btn || !card) return;
        btn.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(spot); });
        if (hoverable) {
          let t;
          spot.addEventListener('mouseenter', () => { clearTimeout(t); this.open(spot); });
          spot.addEventListener('mouseleave', () => { t = setTimeout(() => this.close(spot), 200); });
        }
        spot.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.close(spot); btn.focus(); } });
        spot.addEventListener('focusout', (e) => { if (!spot.contains(e.relatedTarget)) this.close(spot); });
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
      // Chips under the image highlight their hotspot
      const section = this.closest('.purr-hero');
      section && section.querySelectorAll('[data-hotspot-chip]').forEach((chip) => {
        const spot = this.querySelector('#Hotspot-' + chip.dataset.hotspotChip)?.closest('.purr-hotspot');
        if (!spot) return;
        chip.addEventListener('mouseenter', () => spot.classList.add('is-highlight'));
        chip.addEventListener('mouseleave', () => spot.classList.remove('is-highlight'));
        chip.addEventListener('focus', () => spot.classList.add('is-highlight'));
        chip.addEventListener('blur', () => spot.classList.remove('is-highlight'));
      });
      // Intro pulse once when visible
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => { if (entries.some((en) => en.isIntersecting)) { this.classList.add('is-intro'); io.disconnect(); } }, { threshold: 0.4 });
        io.observe(this);
      }
    }
    open(spot) {
      this.spots.forEach((s) => { if (s !== spot) this.close(s); });
      spot.classList.add('is-open');
      spot.querySelector('.purr-hotspot__btn').setAttribute('aria-expanded', 'true');
      spot.querySelector('.purr-hotspot__card').hidden = false;
    }
    close(spot) {
      if (!spot.classList.contains('is-open')) return;
      spot.classList.remove('is-open');
      spot.querySelector('.purr-hotspot__btn').setAttribute('aria-expanded', 'false');
      spot.querySelector('.purr-hotspot__card').hidden = true;
    }
    toggle(spot) { spot.classList.contains('is-open') ? this.close(spot) : this.open(spot); }
    closeAll() { this.spots.forEach((s) => this.close(s)); }
  }
  customElements.define('purr-hotspots', PurrHotspots);
})();
